import { render, staticRenderFns } from "./declarePage.vue?vue&type=template&id=70845f42&"
import script from "./declarePage.vue?vue&type=script&lang=js&"
export * from "./declarePage.vue?vue&type=script&lang=js&"
import style0 from "./declarePage.vue?vue&type=style&index=0&id=70845f42&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports